import { KebabMenu } from '@library/components/menus';
import type { Status } from '@library/types/projection';
import { StatusKebabMenuItems } from '@library/components/menus/StatusKebabMenuItems';
import { classNames } from '@library/utils';

export interface TeamKebabMenuProps {
  disabled?: boolean;
  isBulkTeamInGameEnabled: boolean;
  projectionsExist?: boolean;
  teamBulkActions: {
    handleChangeStatus: (status: Status) => void;
    handleChangeInGame: (inGame: boolean) => void;
  };
  teamModalActions: {
    handleShowGameModes: () => void;
  };
}

export const TeamKebabMenu = ({
  disabled = undefined,
  isBulkTeamInGameEnabled,
  projectionsExist = true,
  teamBulkActions,
  teamModalActions
}: TeamKebabMenuProps) => {
  const { handleChangeStatus, handleChangeInGame } = teamBulkActions;
  const { handleShowGameModes } = teamModalActions;

  return (
    <KebabMenu
      className="relative size-6 self-center"
      disabled={disabled}
      float
      floatPlacement="bottom-end"
      menuButtonClassName={classNames(
        disabled ? 'cursor-not-allowed' : '',
        'h-6 w-6'
      )}
      menuItemsClassName="z-50 border border-soFresh-140 bg-soFresh-110 right-0 w-44 rounded-md"
      menuButtonOpenClassName="bg-soFresh-140 rounded-md"
      title="TeamKababMenu"
    >
      <StatusKebabMenuItems
        disabled={!projectionsExist}
        isBulkInGameEnabled={isBulkTeamInGameEnabled}
        handleChangeStatus={handleChangeStatus}
        handleShowGameModes={handleShowGameModes}
        handleChangeInGame={handleChangeInGame}
      />
    </KebabMenu>
  );
};
